import { render, staticRenderFns } from "./LinkSubmission.vue?vue&type=template&id=28f1f9aa&scoped=true&"
import script from "./LinkSubmission.vue?vue&type=script&lang=js&"
export * from "./LinkSubmission.vue?vue&type=script&lang=js&"
import style0 from "./LinkSubmission.vue?vue&type=style&index=0&id=28f1f9aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f1f9aa",
  null
  
)

export default component.exports